<template>
  <div class="django-page ml-2">
    <h2>Django Support</h2>
    <div class="mt-4">
      <p>PyCrunch can be used as a drop-in replacement of <code>manage.py test</code> command.</p>
      <p>However there are some things to keep in mind if you decided to use PyCrunch together with Django. </p>
      <p>Primary goal of the extension is to run as <span class="font-weight-bold">fast</span> as possible.</p>

      <p>Default Django test runner creates new database each time when tests are run.</p>

      <p>This leads to multiple problems:</p>
      <ul>
        <li>Inability to run tests in parallel;</li>
        <li>Sometimes database got stale, and you need to type <code>yes</code> in terminal in order to destroy it;</li>
        <li>Each test run consumes more resources than it should, by creating database and applying migrations each time;</li>
        <li>Tests are not really unit-tests, sometimes you do not need database at all;</li>
        <li>Cannot run tests (or some code from unit-test) upon data stored in local database.</li>
      </ul>

      <p>In order to eliminate this inconveniences and speed up test execution, PyCrunch will  <span class="font-weight-bold">use same database</span> for running tests as <code>manage.py runserver</code>, without initializing temporary database.</p>

      <p>Be careful when you run your suite for the first time, as it may corrupt data.</p>

      <p>If your insist on using separate database, please create new <code>django.setting</code> module and pass it as environment variable to pycrunch-engine using .pycrunch-config.yaml file in env section, something like:</p>
      <code style="white-space: pre-wrap">engine:
  runtime: django
env:
  DJANGO_SETTINGS_MODULE: djangoapp.settings.pycrunch_local
  DJANGO_ALLOW_ASYNC_UNSAFE: "true"</code>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'django-support.page',
  }
</script>

<style scoped>

</style>